import { createFileRoute } from "@tanstack/react-router";
import Offer from "@/features/tradein/pages/offer/Offer";

export const Route = createFileRoute("/$locale/$partner/_results/offer")({
	component: Offer,
});
